module.exports = __webpack_public_path__ + "img/employee.a45f709f.png";